import {Component, forwardRef, Injector} from "@angular/core";
import {provideSearchModel} from "@fedeltapointofsale/data-client";
import {NG_VALUE_ACCESSOR} from "@angular/forms";
import {AccountTypeSearchModel} from "../account-type-search.model";
import {AccountTypeSearchPageComponent} from "../account-type-search-page/account-type-search-page.component";
import {AccountTypeEditPageComponent} from "../account-type-edit-page/account-type-edit-page.component";
import {
    AbstractSingleSelectEditControlComponent
} from "../../../framework/entity/edit/edit-controls/select-edit-controls/abstract-single-select-edit-control.component";

const CUSTOM_VALUE_ACCESSOR: any = {
    provide: NG_VALUE_ACCESSOR,
    useExisting: forwardRef(() => AccountTypeSingleSelectEditControlComponent),
    multi: true
};

@Component({
    selector: "wbo-account-type-single-select-edit-control",
    templateUrl: "../../../framework/entity/edit/edit-controls/select-edit-controls/single-select-edit-control.component.html",
    providers: [
        CUSTOM_VALUE_ACCESSOR,
        provideSearchModel(AccountTypeSearchModel)
    ]
})
export class AccountTypeSingleSelectEditControlComponent extends AbstractSingleSelectEditControlComponent<AccountTypeSearchModel> {

    constructor(model: AccountTypeSearchModel, injector: Injector) {
        super(model, injector, "id", "name");

        this.extendedSearchComponent = AccountTypeSearchPageComponent;
        this.extendedEditComponent = AccountTypeEditPageComponent;
    }
}
